import React, { useState } from 'react';
import styles from './ForgetPassword.module.css';
import NextButton from "../../components/NextButton/NextButton";
import CancelButton from '../../components/CancelButton/CancelButton';
import LoginLeftSide from '../../components/LoginLeftSide/LoginLeftSide';


const ForgetPassword = ({ onSubmit }) => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ email });
    setEmail('');
  };

  return (
    <div className={styles.loginContainer}>
      <LoginLeftSide />
      <div className={styles.rightSide}>
        <div className={styles.formcontainer}>
          <div className={styles.title}>Forgot your Password?</div>

          <form onSubmit={handleSubmit}>
            <label> Email: </label> <br />
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className={styles.fieldinputs}
            />
            <br />
            <NextButton />
          </form>
          <CancelButton label="Back" />
        </div>
      </div>
    </div>

  );
};

export default ForgetPassword;